export default __webpack_public_path__ + "assets/images/check_box.844e7d3fbf6508b8a16448f0390408fb.png";